import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import Brochure_COE1 from '../../Assets/Images/Brochure/Brochure_COE1.png'
import Brochure_COE2 from '../../Assets/Images/Brochure/Brochure_COE2.png'

const ABrochure = () => {

    return (
        <section>

            <div className="card mt-5">
                <img
                    src={Brochure_COE1}
                    className="card-img-top"
                    alt="Brochure COE"
                />
            </div>
            <div className="card mt-3">
                <img
                    src={Brochure_COE2}
                    className="card-img-top"
                    alt="Brochure COE"
                />
            </div>

        </section>
    );
};

export default ABrochure;